export const unformattedValueGross: number = 184500;
export const unformattedValueNet50: number = 167250;
export const unformattedValueNet: number = 150000;
export const unformattedValueAfter30DaysGross: number = 123000;
export const unformattedValueAfter30DaysNet50: number = 111500;
export const unformattedValueAfter30DaysNet: number = 100000;
export const gapCompensationGross: number = unformattedValueGross - unformattedValueAfter30DaysGross;
export const gapCompensationNet50: number = unformattedValueNet50 - unformattedValueAfter30DaysNet50;
export const gapCompensationNet: number = unformattedValueNet - unformattedValueAfter30DaysNet;
